window.mcb.effects.helpers.scrollToHelper = (function () {
  const _logger = window.mcb.utilities.createLogger('links.scrollToHelper');
  const scrollToSelector = function (target, closestSelector) {
    _logger.log('Scroll To action triggered for: ' + target);
    document.querySelector("body").classList.add('mcp-programmatically-scrolling');

    let targetElement = document.querySelector(target);
    if (targetElement) {
      const closestElement = targetElement.closest(closestSelector);
      if (closestElement) {
        targetElement = closestElement;
      }

      let paddingOffset = 0;
      const paddingTarget = document.querySelector('.mcb-ribbon--content');
      if (paddingTarget !== null) {
        paddingOffset = parseFloat(window.getComputedStyle(paddingTarget, null).getPropertyValue('gap'));
      }

      window.mcb.header.setNavigationScrollState('down');

      const headerOffsetDesktop = document.querySelector(".mcb-page-header_ribbon--second").clientHeight;
      const headerOffsetMobile = document.getElementById('mobile').clientHeight;
      const headerOffset = Math.max(headerOffsetDesktop, headerOffsetMobile);

      const rect = targetElement.getBoundingClientRect();
      const targetOffset = rect.top + window.pageYOffset;

      // Account for current scroll position when calculating target
      window.scrollTo({
        top: targetOffset - headerOffset - paddingOffset,
        behavior: 'smooth'
      });

      setTimeout(function () {
        _logger.log('Re-allow scroll to affect main menu');
        document.querySelector("body").classList.remove('mcp-programmatically-scrolling');
      }, 800);
    }
  };

  window.addEventListener('load', function () {
    const hash = window.location.hash;
    if (hash !== null && hash.length > 1) {
      scrollToSelector(hash);
    }
  });

  const scrollToClick = function (event) {
    event.preventDefault();
    const hash = event.target.getAttribute('href');
    if (hash && hash[0] === '#') {
      // First update the URL
      if (history && history.pushState) {
        history.pushState(null, null, hash);
      } else {
        // Fallback for older browsers
        window.location.hash = hash;
      }
      // Then handle the scroll
      requestAnimationFrame(() => {
        scrollToSelector(hash);
      });
    }
  };

  return _ = {
    scrollToClick: scrollToClick,
    scrollToSelector: scrollToSelector,
    scrollToSelectorsRibbon: function (selector) {
      scrollToSelector(selector);
    }
  }
})();
